import { render, staticRenderFns } from "./WithdrawConfirm.vue?vue&type=template&id=c03a94c8"
import script from "./WithdrawConfirm.vue?vue&type=script&lang=js"
export * from "./WithdrawConfirm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports